import { render, staticRenderFns } from "./SelectStudents.vue?vue&type=template&id=db03a466&scoped=true"
import script from "./SelectStudents.vue?vue&type=script&lang=js"
export * from "./SelectStudents.vue?vue&type=script&lang=js"
import style0 from "./SelectStudents.vue?vue&type=style&index=0&id=db03a466&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db03a466",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db03a466')) {
      api.createRecord('db03a466', component.options)
    } else {
      api.reload('db03a466', component.options)
    }
    module.hot.accept("./SelectStudents.vue?vue&type=template&id=db03a466&scoped=true", function () {
      api.rerender('db03a466', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base-com/select/SelectStudents.vue"
export default component.exports